// 번호 체계별 자릿수까지 본다. 총 자릿수만 세면 010-1234-567 같은 오류가 통과한다.
const TEL_PATTERNS = [
  /^010\d{8}$/, // 휴대폰
  /^01[16789]\d{7,8}$/, // 구 휴대폰(011·016~019)
  /^02\d{7,8}$/, // 서울
  /^0[3-6]\d\d{7,8}$/, // 그 외 지역번호
  /^070\d{8}$/, // 인터넷전화
];

const PhoneNumberUtils = {
  appendDash: (phoneNumber: string) => {
    return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  },

  /** 010 휴대폰만 통과시킨다. 유선번호까지 받아야 하면 isValidTel 을 쓴다. */
  isValid: (phoneNumber?: string) => {
    if (phoneNumber) {
      return new RegExp(/(^010-(?:\d{4})-\d{4}$)|(^(010)\d{4}\d{4}$)/).test(phoneNumber);
    }
    return false;
  },

  /** 휴대폰·유선·인터넷전화를 모두 허용한다. 공백과 하이픈은 무시한다. */
  isValidTel: (phoneNumber?: string) => {
    if (!phoneNumber) {
      return false;
    }
    const digits = phoneNumber.replace(/[\s-]/g, '');
    return TEL_PATTERNS.some((pattern) => pattern.test(digits));
  },
};

export default PhoneNumberUtils;
